<template>
    <div id="abc" style="width: 100%;display: flex;align-items: center;justify-content: center;height: 400px;">
        <!-- <button @click="btn" style="width: 100px;height: 50px;">点击</button> -->
        <div class="loader"></div>
        <!-- <div class="number">
           <span
              v-for="(item, index) in 'loading...'"
              :style="'animation: totop 1.5s ' + 0.1 * index + 's infinite ease-out'"
              :key="index"
               >
       	      {{ item }}
            </span>
        </div> -->
    </div>
</template>
<script>
import { getAlipay } from '@/api/Alipay/Alipay'
import bridge from './dsbridge'
export default{
    name:"Alipay",
    data(){
        return{
            
            
        }
    },
    created(){
        // getAlipay({productInfoId: this.$route.query.productInfoId}).then(res => {
        // const div = document.createElement('div')
        // div.id = 'formdata'
		// div.innerHTML = res
		// document.body.appendChild(div)
        // const form=document.getElementById('formdata');
		// document.forms[0].submit()
        // document.body.removeChild(form)
        // }).catch(() => {
          
        // });
        this.closeWebAndroid()
        this.closeWebIOS()
    },
    methods:{
        closeWebAndroid() {    
            bridge.call("WebAction.closeWeb",{
              payStatus:'11111'
            })
        },

        closeWebIOS() {    
            try {
              //使用此方法,会报错,因此使用try-catch
              webkit.messageHandlers.closeWeb.postMessage({
                payStatus:true
              });
            } catch(error) {
              console.log('WKWebView post message error: ', error);
            }
        },
    }
}
</script>
<style lang="scss">
.number {
  line-height: 250px;
  font-size: 24px;
  color: #000;
  text-align: center;
  span {
    position: relative;
    margin-right: 0px;
  }
}
@keyframes totop {
  0% {
    top: 0;
  }
  24% {
    top: 0;
  }
  33% {
    top: -7px;
  }
  39% {
    top: -7px;
  }
  45% {
    top: 0;
  }
  100% {
    top: 0;
  }
}

$colors:
	  hsla(337, 84, 48, 0.75)
	  hsla(160, 50, 48, 0.75)
	  hsla(190, 61, 65, 0.75)
	  hsla( 41, 82, 52, 0.75);
	$size: 2.5em;
	$thickness: 0.5em;
	
	// Calculated variables.
	$lat: ($size - $thickness) / 2;
	$offset: $lat - $thickness;
	
	.loader {
	  position: relative;
	  width: $size;
	  height: $size;
	  transform: rotate(165deg);
	  
	  &:before,
	  &:after {
	    content: '';
	    position: absolute;
	    top: 50%;
	    left: 50%;
	    display: block;
	    width: $thickness;
	    height: $thickness;
	    border-radius: $thickness / 2;
	    transform: translate(-50%, -50%);
	  }
	  
	  &:before {
	    animation: before 2s infinite;
	  }
	  
	  &:after {
	    animation: after 2s infinite;
	  }
	}
	
	@keyframes before {
	  0% {
	    width: $thickness;
	    box-shadow:
	      $lat (-$offset) nth($colors, 1),
	      (-$lat) $offset nth($colors, 3);
	  }
	  35% {
	    width: $size;
	    box-shadow:
	      0 (-$offset) nth($colors, 1),
	      0   $offset  nth($colors, 3);
	  }
	  70% {
	    width: $thickness;
	    box-shadow:
	      (-$lat) (-$offset) nth($colors, 1),
	      $lat $offset nth($colors, 3);
	  }
	  100% {
	    box-shadow:
	      $lat (-$offset) nth($colors, 1),
	      (-$lat) $offset nth($colors, 3);
	  }
	}
	
	@keyframes after {
	  0% {
	    height: $thickness;
	    box-shadow:
	      $offset $lat nth($colors, 2),
	      (-$offset) (-$lat) nth($colors, 4);
	  }
	  35% {
	    height: $size;
	    box-shadow:
	        $offset  0 nth($colors, 2),
	      (-$offset) 0 nth($colors, 4);
	  }
	  70% {
	    height: $thickness;
	    box-shadow:
	      $offset (-$lat) nth($colors, 2),
	      (-$offset) $lat nth($colors, 4);
	  }
	  100% {
	    box-shadow:
	      $offset $lat nth($colors, 2),
	      (-$offset) (-$lat) nth($colors, 4);
	  }
	}
	
	
	
	/**
	 * Attempt to center the whole thing!
	 */
	
	html,
	body {
	  height: 100%;
	}
	
	.loader {
	  position: absolute;
	  top: calc(50% - #{$size / 2});
	  left: calc(50% - #{$size / 2});
	}
</style>